<div class="timer" [class]="isPast() ? 'past' : 'future'">
    <fa-icon class="mx-2 col-1 d-inline-block" [icon]="['fas', 'clock-rotate-left']"></fa-icon>
    <span>{{ formattedDifference() }}</span>
</div>
